"use strict";

exports.__esModule = true;
exports.Element = void 0;

var _lottie = require("../helpers/lottie.js");

var _utils = require("../helpers/utils.js");

var _manager = require("./manager.js");

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _defaults(subClass, superClass); }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { _defaults(o, p); return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ELEMENT_STYLE = "\n    :host {\n        display: inline-flex;\n        width: 32px;\n        height: 32px;\n        align-items: center;\n        justify-content: center;\n        position: relative;\n        vertical-align: middle;\n        fill: currentcolor;\n        stroke: none;\n        overflow: hidden;\n    }\n\n    svg {\n        pointer-events: none;\n        display: block;\n    }\n\n    div {    \n        width: 100%;\n        height: 100%;\n    }\n\n    div.slot {\n        position: absolute;\n        left: 0;\n        top: 0;\n        z-index: 2;\n    }\n";
var OBSERVED_ATTRIBUTES = ['palette', 'src', 'icon', 'animation', 'speed', 'target', 'params'];

var Element = /*#__PURE__*/function (_HTMLElement) {
  _inheritsLoose(Element, _HTMLElement);

  function Element() {
    var _this;

    _this = _HTMLElement.call(this) || this;
    _this.isReady = false;
    _this.root = _this.attachShadow({
      mode: "open"
    });
    return _this;
  }
  /**
   * Register Lottie library.
   * @param loader Provide "loadAnimation" here from Lottie.
   */


  Element.registerLoader = function registerLoader(loader) {
    (0, _manager.registerLoader)(loader);
  }
  /**
   * Register supported icon.
   * @param name
   * @param data
   */
  ;

  Element.registerIcon = function registerIcon(name, data) {
    (0, _manager.registerIcon)(name, data);
  }
  /**
   * Register supported animation.
   * @param name
   * @param animationClass
   */
  ;

  Element.registerAnimation = function registerAnimation(name, animationClass) {
    (0, _manager.registerAnimation)(name, animationClass);
  }
  /**
   * Element connected.
   */
  ;

  var _proto = Element.prototype;

  _proto.connectedCallback = function connectedCallback() {
    (0, _manager.connectInstance)(this);

    if (!this.isReady) {
      this.init();
    }
  }
  /**
   * Element disconnected.
   */
  ;

  _proto.disconnectedCallback = function disconnectedCallback() {
    this.unregisterLottie();
    (0, _manager.disconnectInstance)(this);
  };

  _proto.attributeChangedCallback = function attributeChangedCallback(name, oldValue, newValue) {
    this[name] = newValue;
    var method = this[name + "Changed"];

    if (method) {
      method.call(this);
    }
  };

  _proto.init = function init() {
    if (this.isReady) {
      return;
    }

    this.isReady = true;
    var style = document.createElement('style');
    style.innerHTML = ELEMENT_STYLE;
    this.root.appendChild(style);
    var slotContainer = document.createElement('div');
    slotContainer.innerHTML = '<slot></slot>';
    slotContainer.classList.add('slot');
    this.root.appendChild(slotContainer);
    var container = document.createElement('div');
    this.root.appendChild(container);
    this.registerLottie();
  };

  _proto.registerLottie = function registerLottie() {
    var _this2 = this;

    var iconData = this.iconData;

    if (!iconData) {
      return;
    }

    if (this.palette || this.params) {
      iconData = (0, _utils.deepClone)(iconData);
    }

    if (this.palette) {
      iconData = (0, _lottie.replacePalette)(iconData, this.palette);
    }

    if (this.params) {
      iconData = (0, _lottie.replaceParams)(iconData, this.params);
    }

    this.lottie = (0, _manager.loadLottieAnimation)({
      container: this.container,
      renderer: 'svg',
      loop: false,
      autoplay: false,
      preserveAspectRatio: 'xMidYMid meet',
      progressiveLoad: true,
      hideOnTransparent: false,
      animationData: iconData
    }); // set speed

    this.lottie.setSpeed(this.animationSpeed); // dispatch animation-complete

    this.lottie.addEventListener('complete', function () {
      _this2.dispatchEvent(new CustomEvent('animation-complete'));
    });
    this.animationChanged();
  };

  _proto.unregisterLottie = function unregisterLottie() {
    if (this.myConnectedAnimation) {
      this.myConnectedAnimation.disconnectedCallback();
      this.myConnectedAnimation = undefined;
    }

    if (this.lottie) {
      this.lottie.destroy();
      this.lottie = undefined;
      this.container.innerHTML = '';
    }
  };

  _proto.notify = function notify(name, from) {
    if (this[from] !== name) {
      return;
    }

    if (from === 'icon' && !this.lottie) {
      this.registerLottie();
    } else if (from === 'animation' && !this.myConnectedAnimation) {
      this.animationChanged();
    }
  };

  _proto.animationChanged = function animationChanged() {
    if (this.myConnectedAnimation) {
      this.myConnectedAnimation.disconnectedCallback();
      this.myConnectedAnimation = undefined;
    }

    if (this.animation && this.lottie) {
      var AnimationClass = (0, _manager.getAnimation)(this.animation);

      if (AnimationClass) {
        // find target event listener
        var target = this.target ? this.closest(this.target) : null;
        this.myConnectedAnimation = new AnimationClass(this, target || this, this.lottie);
        this.myConnectedAnimation.connectedCallback();
      }
    }
  };

  _proto.paletteChanged = function paletteChanged() {
    if (!this.isReady) {
      return;
    }

    this.unregisterLottie();
    this.registerLottie();
  };

  _proto.paramsChanged = function paramsChanged() {
    if (!this.isReady) {
      return;
    }

    this.unregisterLottie();
    this.registerLottie();
  };

  _proto.speedChanged = function speedChanged() {
    if (this.lottie) {
      this.lottie.setSpeed(this.animationSpeed);
    }
  };

  _proto.iconChanged = function iconChanged() {
    if (!this.isReady) {
      return;
    }

    this.unregisterLottie();
    this.registerLottie();
  };

  _proto.srcChanged = /*#__PURE__*/function () {
    var _srcChanged = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!this.src) {
                _context.next = 3;
                break;
              }

              _context.next = 3;
              return (0, _manager.loadIcon)(this.src);

            case 3:
              if (this.isReady) {
                _context.next = 5;
                break;
              }

              return _context.abrupt("return");

            case 5:
              this.unregisterLottie();
              this.registerLottie();

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function srcChanged() {
      return _srcChanged.apply(this, arguments);
    }

    return srcChanged;
  }()
  /**
   * Acces icon data for this element.
   */
  ;

  _createClass(Element, [{
    key: "iconData",
    get: function get() {
      return (0, _manager.getIcon)(this.icon || this.src);
    }
    /**
     * Access current animation instance.
     */

  }, {
    key: "connectedAnimation",
    get: function get() {
      return this.myConnectedAnimation;
    }
  }, {
    key: "container",
    get: function get() {
      return this.root.lastElementChild;
    }
  }, {
    key: "animationSpeed",
    get: function get() {
      return this.speed ? parseFloat(this.speed) || 1 : 1;
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return OBSERVED_ATTRIBUTES;
    }
  }]);

  return Element;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

exports.Element = Element;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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